import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { INVENTORY_SETUP } from "../apiRoutes";

const mutateToggleInventorySetup = async ({ id }: { id: string | number }) => {
	return await axiosAuth.patch(`${INVENTORY_SETUP}${id}`);
};

const useToogleInventorySetupMutation = (
	queryParams?: UseMutationOptions<
		any,
		Error,
		{
			id: string | number;
		},
		unknown
	>
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: mutateToggleInventorySetup,
		onSuccess: (data, variables, context) => {
			queryClient.invalidateQueries({ queryKey: ["inventorySetup"], exact: false });
			queryParams?.onSuccess?.(data, variables, context);
		},
		...queryParams,
	});
};

export default useToogleInventorySetupMutation;
